/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-shadow */
import { ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  EventEmitter,
  Renderer2,
  Output,
  OnInit,
  ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { AutoUnsubscribe } from 'src/app/shared/decorators/auto-unsubcribe';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { UserService } from 'src/app/shared/services/user.service';
import { messagesConfig } from 'src/app/shared/constants/message.constants';
import { WorkSheetType } from 'src/app/features/worksheet/models/native-soill-worksheet-type.modal';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { AdminHeader } from 'src/app/shared/models/admin-header.model';
import { AllAdminService } from 'src/app/shared/services/all-admin.service';
import { Observable } from 'rxjs';
import { SharedService } from 'src/app/features/service/shared.service';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { MatTable } from '@angular/material/table';
import { IDropdown } from 'src/app/shared/models/i-dropdown-type.modal';
import { DateTimeUtils } from 'src/app/shared/util/date-time.utils';
import { SelectionModel } from '@angular/cdk/collections';
import { NativeSoilService } from '../../services/native-soil/native-soil.service';
import { AssignToLabtechComponent } from '../../../../shared/components/assign-to-labtech/assign-to-labtech.component';
import { EditNativeSoilWorksheetComponent } from '../edit-native-soil-worksheet/edit-native-soil-worksheet.component';
import { NativeSoilType } from '../../models/native-soil-worksheet.modal';
import { MatSnackBar } from '@angular/material/snack-bar';
import { WorksheetResponse } from '../../models/worksheet-response.modal';
import { NativesoilTechWorksheetPdfService } from './nativesoil-tech-worksheet-pdf.service';

@AutoUnsubscribe
@Component({
    selector: 'app-nativesoil-table',
    templateUrl: './nativesoil-table.component.html',
    styleUrls: ['./nativesoil-table.component.scss'],
    providers: [DatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NativesoilTableComponent implements OnInit {
  @ViewChild(MatTable) table: MatTable<any>;
  dragDisabled = true;
  isDataChanged = false;
  userRoles: string[];
  @HostListener('click', ['$event'])
  onClick(event: Event) {
    let exists = false;
    const elementWithClass = this.el.nativeElement.querySelector('.pop-des-show');
    if (elementWithClass) {
      exists = true;
      this.renderer.removeClass(elementWithClass, 'pop-des-show');
    }
    const { nativeElement } = this.el;
    this.renderer.removeClass(nativeElement, 'pop-des-show');
    const clickedElement = event.target as HTMLElement;
    const { className } = clickedElement;
    if (className.includes('cli')) {
      exists = true;
    } else {
      exists = false;
      const element = this.el.nativeElement.querySelector('.cli');
      if (element) {
        this.renderer.removeClass(element, 'cli');
      }
    }
    clickedElement.classList.add('cli');
    if (className.includes('des-ico')) {
      const specificParent = this.findSpecificParent(clickedElement, 'td-des');
      if (specificParent) {
        if (!exists) {
          specificParent.classList.add('pop-des-show');
        } else {
          clickedElement.classList.remove('cli');
        }
      }
      this.cd.detectChanges();
    }
  }

  tabEnable = false;

  @Input() projectId: string;
  @Input() instructionConfirmed: boolean;
  @Input() projectStatuses : IDropdown[];
  @Input() projectStatusId : string;
  @Output() assigned = new EventEmitter<boolean>();
  @Input() worksheetRecords!: WorksheetResponse;
  displayedColumns: string[] = [];
  headerColumn: any[] = [];
  dataSource: NativeSoilType[] = [];
  dataSourceParent : NativeSoilType[] = [];
  isManagerAdmin = false;
  isEdit = false;
  receivedWorkSheet = [];
  moistureWorksheets = [];
  proctorWorksheets = [];
  workSheets = [];
  showTable = false;
  isBulk = true;
  activetab = 'receivedSheet';
  tableShow = true;
  showWeightsAndMoisturesButton = false;
  actionButtonEnable = false;
  isLabTech = false;
  tabAssign = true;
  tabOpenTech = true;
  allResponseWorksheet: any;
  allWorksheetApiRes:any;
  headerData: AdminHeader[] = [];
  headerKeyToRowKeyMapping: { [key: string]: string } = {
  };

  activeTabIndex = 0;
  noTasksMessage = '';

  selection = new SelectionModel<NativeSoilType>(true, []);

  @Output() allResNativeWorksheet = new EventEmitter<any>();
  asRecivedWorksheetsData: AdminHeader[] = [];
  moistureWorksheetsData: AdminHeader[] = [];
  nativeSoilWorksheetsData: AdminHeader[] = [];
  proctorWorksheetsData: AdminHeader[] = [];

  @Output() fetchAllHeader = new EventEmitter<{
    asRecivedWorksheets: AdminHeader[],
    moistureWorksheets: AdminHeader[],
    nativeSoilWorksheets: AdminHeader[],
    proctorWorksheets: AdminHeader[]
  }>();

  @Output() rowDeletionSuccess = new EventEmitter<void>();
  checkEnableOpentTechWorkSheet = true;
  readonly TAB = {
    RECEIVED: 'receivedSheet',
    MOISTURE: 'moistureWorksheets',
    PROCTOR: 'proctorWorksheets',
    WORKSHEET: 'workSheet'
  };
  constructor(
    public userService: UserService,
    private dialogService: DialogService,
    private dialog: MatDialog,
    private cd: ChangeDetectorRef,
    private el: ElementRef,
    private renderer: Renderer2,
    private nativeSoilService: NativeSoilService,
    private adminService: AllAdminService,
    private sharedService:SharedService,
    private snackBar: MatSnackBar,
    private nativeSoilTechWorksheetPdfService: NativesoilTechWorksheetPdfService
  ) {}

  ngOnInit() {
    this.userAccountAndRole();
    this.getWorkSheets(this.projectId);
    this.fetchTabsData();
    this.checkForEnableOpentTechWorkSheet();
  }
  
  userAccountAndRole() {
    this.userService.userRole?.subscribe({
      next: (roles) => {
        this.userRoles = roles || [];
        this.isManagerAdmin = this.roleCheck(['Manager', 'Admin']);
        this.isLabTech = this.roleCheck(['Labtech']);
        this.isEdit = this.roleCheck(['Manager', 'Labtech', 'Admin']);
      }
    });
  }  
  
  roleCheck(roles: string[]): boolean {
    return roles.some((role) => this.userRoles.includes(role));
  }

  shouldHideSortColumn(): boolean {
    const totalRows = this.dataSource.length;
    const parentRowsCount = this.dataSource.filter((row) => row.parentRow === true).length;

    return (
      totalRows === 1
      || (totalRows > 1 && parentRowsCount === 1)
      || !this.isUserManagerOrAdmin()
    );
  }

  isUserManagerOrAdmin(): boolean {
    return this.roleCheck(['Manager', 'Admin']);
  }

  onDataLoaded(data: any) {
    this.allResNativeWorksheet.emit(data);
  }

  dragDrop(event: CdkDragDrop<any>) {
    this.dragDisabled = true;
    const draggedRow = event.item.data;
    const { currentIndex } = event;
    const { previousIndex } = event;
    if (this.activetab === 'workSheet') {
      if (draggedRow.parentRow) {
        const selectedRows = this.getGroupRows(draggedRow);
        const droppedRow: any = this.dataSource[currentIndex];

        const isDroppedOnChild = this.getGroupRows(droppedRow).some(
          (row: any) => row.parentRow === false && row.groupId !== null && row.groupId === draggedRow.groupId,
        );

        if (isDroppedOnChild) {
          return;
        }

        const dummy: any = [];
        const selectedDropRows = this.getGroupRows(droppedRow);

        this.dataSource.forEach((each: any, i: number) => {
          if (
            selectedRows[0].groupId !== each.groupId
                  && droppedRow.groupId !== each.groupId
          ) {
            dummy.push(each);
          } else {
            dummy.push({
              inHouseId: 'null',
            });
          }

          if (i === currentIndex) {
            if (currentIndex === previousIndex) {
              dummy.push(...selectedDropRows);
            } else if (currentIndex > previousIndex) {
              dummy.push(...selectedDropRows);
              dummy.push(...selectedRows);
              this.isDataChanged = true;
            } else {
              dummy.push(...selectedRows);
              dummy.push(...selectedDropRows);
              this.isDataChanged = true;
            }
          }
        });

        const actualObject: any = [];
        dummy.forEach((elem: any) => {
          if (elem.inHouseId !== 'null') {
            actualObject.push(elem);
          }
        });

        this.dataSource = actualObject;
        this.table.renderRows();
      }
    } else if (this.activetab === 'moistureWorksheets') {
      if (draggedRow.parentRow) {
        const selectedRows = this.getGroupRows(draggedRow);
        const droppedRow = this.dataSource[currentIndex];

        const isDroppedOnChild = this.getGroupRows(droppedRow).some(
          (row: any) => row.parentRow === false && row.groupId !== null && row.groupId === draggedRow.groupId,
        );

        if (isDroppedOnChild) {
          return;
        }

        const dummy: any = [];
        const selectedDropRows = this.getGroupRows(droppedRow);
        this.dataSource.forEach((each: any, i: number) => {
          const matchSelectedRowIndex = selectedRows.findIndex((x:any) => x.id === each.id);

          const matchDroppedRowIndex = selectedDropRows.findIndex((x:any) => x.id === each.id);

          if (
            (matchSelectedRowIndex === -1)
                  && (matchDroppedRowIndex === -1)
          ) {
            dummy.push(each);
          } else {
            dummy.push({
              projectId: 'null',
            });
          }

          if (i === currentIndex) {
            if (currentIndex === previousIndex) {
              dummy.push(...selectedDropRows);
            } else if (currentIndex > previousIndex) {
              dummy.push(...selectedDropRows);
              dummy.push(...selectedRows);
              this.isDataChanged = true;
            } else {
              dummy.push(...selectedRows);
              dummy.push(...selectedDropRows);
              this.isDataChanged = true;
            }
          }
        });

        const actualObject: any = [];
        dummy.forEach((elem: any) => {
          if (elem.projectId !== 'null') {
            actualObject.push(elem);
          }
        });

        this.dataSource = actualObject;

        this.table.renderRows();
      }
    } else {
      if (currentIndex === previousIndex) {
        return;
      }
      const movedItem = this.dataSource.splice(previousIndex, 1)[0];
      this.dataSource.splice(currentIndex, 0, movedItem);
      this.isDataChanged = true;
      this.table.renderRows();
    }
  }

  saveWorksheet() {
    this.dataSource.forEach((elem: any, i) => {
      elem.sortOrder = i + 1;
      elem.assignedTo = null;
      if (elem.collectionDate) {
        const date = new Date(elem.collectionDate);

        elem.collectionDate = isNaN(date.getTime())
          ? null
          : date.toISOString();
      } else {
        elem.collectionDate = null;
      }
    });

    this.nativeSoilService
      .updateWorksheetSortingAsReceived(this.dataSource, this.activetab)
      .subscribe(
        () => this.getWorkSheets(this.projectId),
        (error) => console.error('Error saving data', error)
      );

    this.table.renderRows();
    this.isDataChanged = false;
  }

  getGroupRows(row: any): any[] {
    if (row.parentRow && row.groupId != null) {
      return this.dataSource.filter((item: any) => item.groupId === row.groupId);
    }

    if (row.parentRow && row.groupId === null) {
      return this.dataSource.filter((item: any) => (item.groupId === row.groupId) && (item.id === row.id));
    }

    const parentRow: any = this.dataSource.find(
      (item: any) => item.groupId === row.groupId && item.parentRow,
    );
    return parentRow ? this.dataSource.filter((item: any) => item.groupId === parentRow.groupId) : [];
  }

  private processWorksheetTab() {
    this.showWeightsAndMoisturesButton = false;
    this.headerColumn = [];
    this.activetab = 'workSheet';

    var moistureStatus = false;
    var asReceivedStatus = false;
    var proctorStatus = false;
    if (this.allResponseWorksheet.proctorWorksheets.length > 0) {
      asReceivedStatus = true;
      moistureStatus = true;
      proctorStatus = this.allResponseWorksheet.proctorWorksheets.some((w: any) => w.status);
    } else {
      asReceivedStatus = this.allResponseWorksheet.asRecivedWorksheets.some((w: any) => w.status);
      moistureStatus = this.allResponseWorksheet.moistureWorksheets.some((w: any) => w.status);
      proctorStatus = true;
    }
    const nativeSoilTypes = this.allResponseWorksheet.nativeSoilWorksheets.map((w: any) => w.worksheetType);

    const hasBulk = nativeSoilTypes.includes('Bulk');
    const isLabtech = this.roleCheck(['Labtech']);

    if (hasBulk) {
      if (!isLabtech) {
        this.tabAssign = asReceivedStatus && moistureStatus && proctorStatus;
      } else {
        this.tabAssign = true;
      }
    } else {
      this.tabAssign = true;
    }

    this.adminService.getNativeCompaction().subscribe({
      next: (response) => this.initializeWorksheetView(response, this.workSheets, []),
    });
  }

  private processMoistureWorksheetsTab() {
    this.processTab({
      tabName: 'moistureWorksheets',
      worksheetData: this.moistureWorksheets,
      apiCall: () => this.adminService.getNativeMoisture(),
      showSWT: true,
    });
  }

  private processReceivedSheetTab() {
    this.processTab({
      tabName: 'receivedSheet',
      worksheetData: this.receivedWorkSheet,
      apiCall: () => this.adminService.getNativeReceived(),
      showSWT: false,
      assignParentDirectly: true,
    });
  }

  private processProctorWorksheetsTab() {
    this.processTab({
      tabName: 'proctorWorksheets',
      worksheetData: this.proctorWorksheets,
      apiCall: () => this.adminService.getNativeProctor(),
      showSWT: false,
      assignParentDirectly: true,
    });
  }

  private processTab(config: {
    tabName: string;
    worksheetData: any[];
    apiCall: () => Observable<any>;
    showSWT: boolean;
    assignParentDirectly?: boolean;
  }) {
    this.showWeightsAndMoisturesButton = config.showSWT;
    this.tabAssign = true;
    this.headerColumn = [];
    this.activetab = config.tabName;

    config.apiCall().subscribe({
      next: (response) => this.initializeWorksheetView(
        response,
        config.worksheetData,
        config.assignParentDirectly ? config.worksheetData : [],
      ),
    });
  }

  private initializeWorksheetView(
    headerData: any[],
    worksheetData: any[],
    parentRows: any[] = [],
  ) {
    this.headerData = headerData.sort((column1, column2) => column1.sortOrder - column2.sortOrder);
    this.displayedColumns = ['select', ...this.headerData.map((h) => h.key)];
    this.dataSource = worksheetData;

    if (!parentRows.length) {
      this.dataSourceParent = worksheetData.filter((w: any) => w.parentRow === true);
    } else {
      this.dataSourceParent = parentRows;
    }

    this.handleEmptyData(worksheetData);
    this.getColumnkeyMatch();
    this.cd.detectChanges();
  }

  getColumnkeyMatch() {
    this.headerKeyToRowKeyMapping = {
    };
    this.headerData.forEach((header) => {
      this.headerKeyToRowKeyMapping[header.key] = header.key;
    });
  }

  getTooltipText(columnName: string): string {
    const header = this.headerData.find((header) => header.key === columnName);
    return header ? header.tooltipText : '';
  }

  // Displays the header value based on sorted order
  getDisplayName(columnName: string): string {
    const header = this.headerData.find((header) => header.key === columnName);
    if (header) {
      return header.units ? `${header.displayName}<br> ${header.units}` : header.displayName;
    }
    return '';
  }

  // Displays the column row value
  getRowDataByKey(row: any, key: string): string {
    const rowKey = this.headerKeyToRowKeyMapping[key];
    const value = row[rowKey];
    if (key === 'collectionDate') {
      if (value === null) {
        return '';
      }
      return DateTimeUtils.formatDateAndTime(value, 'MM/dd/yyyy').toString();
    }
    if (key === 'depth') {
      if (value === null) {
        if (row.stockPile === true) {
          return 'Stockpile';
        }
        if (row.endDepth !== null && !Number.isNaN(row.endDepth)) {
          return `-${row.endDepth}`;
        }
        return '';
      }
      if (row.endDepth !== null && !Number.isNaN(row.endDepth)) {
        return `${row.depth}-${row.endDepth}`;
      }

      return `${row.depth}`;
    }
    if (key === 'effort' && row.worksheetType === 'Tube') {
      return 'Tube';
    }
    if (key === 'compactionEffort') {
      if (value === 0 || value === '0') {
        return 'Dump';
      }
      return value;
    }
    if (key === 'effort') {
      if (value === 0 || value === '0') {
        return 'Dump';
      }
      return value;
    }
    if (key === 'assignedTo') {
      if (typeof value === 'object' && value !== null) {
        const { firstName, lastName } = value;
        if (firstName && lastName) {
          return `${firstName} ${lastName}`;
        }
      } else if (typeof value === 'string') {
        return value;
      }
    }
    return value;
  }

  onTabChanged(event: MatTabChangeEvent) {
    if (!event || !event.tab || !event.tab.textLabel) {
      return;
    }
    const tabId = event.tab.textLabel;
    switch (tabId) {
      case 'As Received M/C':
        this.tabChange(this.TAB.RECEIVED);
        break;
      case 'Moisture Conditioning Sheet':
        this.tabChange(this.TAB.MOISTURE);
        break;
      case 'Single Proctor':
        this.tabChange(this.TAB.PROCTOR);
        break;
      case 'Worksheet':
        this.tabChange(this.TAB.WORKSHEET);
        break;
    }
  }

  tabChange(tabId: string): void {
    this.selection.clear();
    switch (tabId) {
      case this.TAB.RECEIVED:
        this.processReceivedSheetTab();
        break;
      case this.TAB.MOISTURE:
        this.processMoistureWorksheetsTab();
        break;
      case this.TAB.PROCTOR:
        this.processProctorWorksheetsTab();
        break;
      case this.TAB.WORKSHEET:
        this.processWorksheetTab();
        break;
    }
  }

  getWorkSheets(projectId: string): void {
    this.selection.clear();
    this.nativeSoilService.getNativeSoilWorkSheet(projectId).subscribe({
      next: (response: any) => {
        let initial = 1;
        this.allResponseWorksheet = response;

        // excel export data  started
        const allWorksheetApiRes = JSON.parse(JSON.stringify(response));
        const updateDepth = (worksheet: any) => {
          if (worksheet.depth == null && worksheet.endDepth === null && worksheet.stockPile === false) {
            worksheet.depth = '';
          } else if (worksheet.depth == null && worksheet.endDepth === null && worksheet.stockPile === true) {
            worksheet.depth = 'StockPile';
          } else if (worksheet.depth !== null && worksheet.endDepth === null) {
            worksheet.depth = `${worksheet.depth}`;
          } else if (worksheet.depth !== null && worksheet.endDepth !== null) {
            worksheet.depth = `${worksheet.depth}-${worksheet.endDepth}`;
          }
        };

        const customEffort = (worksheet: any) => {
          if (worksheet.worksheetType === 'Tube') {
            worksheet.effort = 'Tube';
          }
        };

        // to export the date value to excel so we avoid the time stamp
        const customDate = (worksheet: any) => {
          if (worksheet.collectionDate) {
            worksheet.collectionDate = DateTimeUtils.formatDateAndTime(worksheet.collectionDate, 'MM/dd/yyyy');
          }
        };

        const customAssignTo = (worksheet: any) => {
          if (worksheet.assignedTo) {
            const updatedByFirstName = worksheet.assignedTo?.firstName;
            const updatedByLastName = worksheet.assignedTo?.lastName;
            worksheet.assignedTo = `${updatedByFirstName} ${updatedByLastName}`;
          }
        };
        // excel export data  ended
        this.receivedWorkSheet = response?.asRecivedWorksheets;
        this.receivedWorkSheet.forEach((worksheet: any) => {
          if (!worksheet.groupOrder) {
            initial += 1;
          }
          worksheet.sequence = initial;
          if (worksheet.collectionDate) {
            worksheet.collectionDate = DateTimeUtils.formatDateAndTime(worksheet.collectionDate, 'MM/dd/yyyy');
          }
          worksheet.displayDepth = this.setDepth(worksheet);
          worksheet.assignedTo = this.mapUser(worksheet);
        });
        initial = 1;
        this.moistureWorksheets = response?.moistureWorksheets;
        // NSMP this.moistureWorksheets = response?.moistureWorksheets.filter((ws: any) => ws.parentRow);
        this.moistureWorksheets.forEach((worksheet: any) => {
          if (!worksheet.groupOrder) {
            initial += 1;
          }
          worksheet.sequence = initial;
          worksheet.assignedTo = this.mapUser(worksheet);
        });
        initial = 1;
        this.proctorWorksheets = response?.proctorWorksheets;
        this.proctorWorksheets.forEach((worksheet: any) => {
          if (!worksheet.groupOrder) {
            initial += 1;
          }
          worksheet.sequence = initial;
          worksheet.displayDepth = this.setDepth(worksheet);
          worksheet.assignedTo = this.mapUser(worksheet);
        });
        initial = 1;
        this.workSheets = response?.nativeSoilWorksheets;
        this.workSheets.forEach((worksheet: any) => {
          if (!worksheet.groupOrder) {
            initial += 1;
          }
          worksheet.sequence = initial;
          worksheet.displayDepth = this.setDepth(worksheet);
          worksheet.assignedTo = this.mapUser(worksheet);
        });
        if (
          this.receivedWorkSheet.length === 0
          && this.moistureWorksheets.length === 0
          && this.proctorWorksheets.length === 0
        ) {
          this.isBulk = false;
          this.activetab = 'workSheet';
          this.workSheets.forEach((elem: NativeSoilType) => {
            if (elem?.worksheetType === 'Bulk') {
              this.isBulk = true;
              this.activetab = 'receivedSheet';
            }
          });
        }

        // received worksheets
        (allWorksheetApiRes.asRecivedWorksheets || []).forEach((worksheet: any) => {
          updateDepth(worksheet);
          customAssignTo(worksheet);
          customDate(worksheet);
        });

        // moisture worksheets
        (allWorksheetApiRes.moistureWorksheets || []).forEach((worksheet: any) => {
          updateDepth(worksheet);
          customAssignTo(worksheet);
        });

        // proctor worksheets
        (allWorksheetApiRes.proctorWorksheets || []).forEach((worksheet: any) => {
          updateDepth(worksheet);
          customAssignTo(worksheet);
        });

        // native soil worksheets
        (allWorksheetApiRes.nativeSoilWorksheets || []).forEach((worksheet: any) => {
          updateDepth(worksheet);
          customEffort(worksheet);
          customAssignTo(worksheet);
        });

        this.allWorksheetApiRes = allWorksheetApiRes;
        this.allResNativeWorksheet.emit(this.allWorksheetApiRes);
        this.getWorkSheetType(this.activetab);
        this.tabChange(this.activetab);
        this.showTable = true;
        this.cd.detectChanges();
      },
      error: (err) => {
        console.error('Error fetching worksheets:', err);
      },
    });
  }

  private mapUser(worksheet: any): string | null {
    if (worksheet.assignedToId) {
      return `${worksheet.assignedTo.firstName} ${worksheet.assignedTo.lastName}`;
    }
    return null;
  }

  setDepth(elem: any): string {
    let depthRange = '';
    if (elem.depth !== null) {
      depthRange = `${elem.depth}`;
    }
    if (elem.endDepth) {
      if (elem.depth !== null && elem.endDepth === null) {
        depthRange = `${elem.depth}`;
      }
      if (elem.endDepth !== null && elem.depth !== null) {
        depthRange = `${elem.depth}-${elem.endDepth}`;
      }
    }
    return depthRange;
  }

  assignTo(worksheetId: NativeSoilType): void {
    this.dialog
      .open(AssignToLabtechComponent, {
        data: {
          worksheetId,
          type: this.activetab,
          multipleSelected: this.isMultipleSelected(worksheetId),
          worksheetRows: this.selection.selected,
          totalNumOfWorksheets: this.dataSource.length,
          role: this.userRoles
        },
        disableClose: true,
        width: '40%',
      })
      .afterClosed()
      .subscribe((assigned) => {
        if (assigned) {
          this.getWorkSheets(this.projectId);
          this.rowDeletionSuccess.emit();
          this.assigned.emit(true);
        }
      });
  }

  editWorksheet(element: NativeSoilType): void {
    if(this.activetab == 'moistureWorksheets' && this.checkForMoisturesheetsValid(element)) {
      this.snackBar.open('Testing amount(gm) or testing moisture points are not completed', 'CLOSE', {
        duration: 3000,
        verticalPosition: 'top',
        panelClass: ['default-snackbar'],
      });
    } else {
      const workSheetType = this.getWorkSheetType(this.activetab, 'edit');
      this.dialog
      .open(EditNativeSoilWorksheetComponent, {
        panelClass: 'worksheet-dialog',
        data: {
          element,
          worksheets: workSheetType.worksheet,
          mode: 'UPDATE',
          workSheetType: this.activetab,
          title: workSheetType.title,
          modalType: 'edit',
          isBulk: this.isBulk,
          isForm: workSheetType.isForm,
          role: this.userRoles,
        },
        disableClose: true,
        width: '50%',
      })
      .afterClosed()
      .subscribe((value: string) => {
        if (value !== 'CLOSED') {
          this.getWorkSheets(this.projectId);
          this.rowDeletionSuccess.emit();
        }
      });
    }
  }

  setWeightnTests(element: NativeSoilType): void {
    const workSheetType = this.getWorkSheetType(this.activetab, 'mswt');
    this.dialog
      .open(EditNativeSoilWorksheetComponent, {
        panelClass: 'worksheet-dialog',
        data: {
          element,
          worksheets: workSheetType.worksheet,
          mode: 'UPDATE',
          workSheetType: this.activetab,
          title: `${workSheetType.title} - Settings`,
          modalType: 'mswt',
          isBulk: this.isBulk,
          isForm: true,
          role: this.userRoles
        },
        disableClose: true,
        width: '50%',
      })
      .afterClosed()
      .subscribe((value: string) => {
        if (value !== 'CLOSED') {
          this.getWorkSheets(this.projectId);
          this.rowDeletionSuccess.emit();
        }
      });
  }

  deleteWorksheet(id: string): void {
    const ws = this.getWorkSheetType(this.activetab);
    let canDelete = false;

    switch (this.activetab) {
      case this.TAB.RECEIVED:
        canDelete = this.receivedWorkSheet.length > 1;
        break;
      case this.TAB.MOISTURE:
        canDelete = this.moistureWorksheets.length > 1;
        break;
      case this.TAB.PROCTOR:
        canDelete = this.proctorWorksheets.length > 1;
        break;
      case this.TAB.WORKSHEET:
        canDelete =
          this.workSheets.filter(
            (worksheet: NativeSoilType) =>
              !(worksheet.worksheetType === 'Tube' && !worksheet.parentRow)
          ).length > 1;
        break;
    }
    if (canDelete) {
      this.dialog
        .open(ConfirmationDialogComponent, {
          panelClass: 'worksheet-dialog',
          data: {
            title: 'Delete',
            content: 'Are you sure you want to delete?',
          },
          disableClose: true,
        })
        .afterClosed()
        .subscribe((response?: string) => {
          if (response === 'YES') {

            this.nativeSoilService
              .deleteNativeSoilWorksheet(id, ws.type)
              .subscribe({
                next: () => {
                  this.getWorkSheets(this.projectId);
                  this.rowDeletionSuccess.emit();
                  this.dialogService.open(
                    messagesConfig.worksheetDeleteMessage
                  );
                },
                error: () => {},
              });

          }
        });
    } else {
      this.dialogService.open(
        messagesConfig.worksheetDeleteValidation
      );
    }
  }

  getWorkSheetType(workSheetType: string, modelType?: string): WorkSheetType {
    let type = 0;
    let title = '';
    let worksheet;
    let isForm = false;
    switch (workSheetType) {
      case 'receivedSheet':
        type = 0;
        title = 'Native Soil Data';
        worksheet = this.receivedWorkSheet;
        isForm = true;
        break;
      case 'moistureWorksheets':
        type = 1;
        title = 'Moisture Conditioning Sheet';
        if (modelType === 'mswt') {
          worksheet = this.moistureWorksheets.filter((element: any) => element.parentRow);
        } else {
          worksheet = this.moistureWorksheets.filter((element: any) => !this.checkForMoisturesheetsValid(element));
        }
        isForm = false;
        break;
      case 'workSheet':
        type = 2;
        title = 'Worksheet';
        worksheet = this.workSheets.filter((element: any) => !element.groupOrder || element.worksheetType === 'Bulk');
        isForm = true;
        break;
      case 'proctorWorksheets':
        type = 3;
        title = 'Single Point Proctor - As Rcvd M/C';
        worksheet = this.proctorWorksheets;
        isForm = true;
        break;
      default:
        type = 0;
        title = 'Native Soil Data';
        worksheet = this.receivedWorkSheet;
        isForm = true;
        break;
    }
    return {
      type,
      title,
      worksheet,
      isForm,
    };
  }

  findSpecificParent(element: HTMLElement, parentClassName: string): HTMLElement | null {
    while (element && !element.classList.contains(parentClassName)) {
      element = element.parentNode as HTMLElement;
    }
    return element;
  }

  checkForEditEnable(worksheet: NativeSoilType): boolean {
    if (this.activetab === 'moistureWorksheets') {
      return this.checkForMoisturesheetsValid(worksheet);
    }
    if (this.activetab === 'proctorWorksheets') {
      return this.checkForProctorsheetsValid(worksheet);
    }
    if (this.activetab === 'workSheet') {
      return this.checkForWorksheetValid(worksheet);
    }
    return false;
  }

  checkForMoisturesheetsValid(worksheet: NativeSoilType): boolean {
    if (Number(worksheet.drySoil) !== 0 && Number(worksheet.moistureContent) !== 0) {
      return false;
    }
    return true;
  }

  checkForProctorsheetsValid(worksheet: NativeSoilType): boolean {
    // if (Number(worksheet.moistureContent) !== 0 && Number(worksheet.drySoil) !== 0) {
    //   return false;
    // }
    return false;
  }

  checkForWorksheetValid(worksheet: NativeSoilType): boolean {
    if (worksheet.assignedTo !== null && (worksheet.worksheetType === 'Tube' || worksheet.worksheetType === 'Bulk')) {
      return false;
    }
    return true;
  }

  enableActionMenu(worksheet: NativeSoilType): boolean {
    if (!this.roleCheck(['Manager', 'Labtech', 'Admin'])) {
      return false;
    }

    if (this.activetab !== 'workSheet') {
      return true;
    }
    return !worksheet.reUse;
  }

  // export .xlsx file that purpose only create // starting
  fetchTabsData(): void {
    this.sharedService.fetchAllTabsData();
    this.sharedService.headerData$.subscribe((data) => {
      if (data) {
        this.fetchAllHeader.emit(data);
      }
    });
  }

  // export .xlsx file that purpose only create // ending
  private handleEmptyData(responseData: any[]): void {
    if (!responseData || responseData.length === 0) {
      this.noTasksMessage = 'No tasks assigned';
    }
  }

  checkForEnableOpentTechWorkSheet() : boolean {
    const index = this.projectStatuses.findIndex((x) => x.id === this.projectStatusId);

    if (index > -1) {
      switch (this.projectStatuses[index].label) {
        case 'Samples Due To Arrive':
        case 'Shipment Received':
        case 'Awaiting Instructions':
        case 'Testing In Progress':
          this.checkEnableOpentTechWorkSheet = false;
          return this.checkEnableOpentTechWorkSheet;
        default:
      }
    }
    return false;
  }

  enableOpenTecWorksheet(rowStatus: boolean, assignTo: string) {
    if (!rowStatus && assignTo) {
      return false;
    }
    if (rowStatus) {
      return false;
    }
    return true;
  }

  showCheckboxIfInParent(row: any) {
    return this.dataSourceParent.includes(row);
  }

  isAllSelected() {
    return this.selection.selected.length === this.dataSourceParent.length;
  }

  isIndeterminate() {
    return this.selection.selected.length > 0 && !this.isAllSelected();
  }

  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      this.selection.select(...this.dataSourceParent);
    }
  }

  toggleSelection(row: NativeSoilType) {
    const index = this.selection.selected.indexOf(row);
    if (index >= 0) {
      this.selection.selected.splice(index, 1);
    } else {
      this.selection.selected.push(row);
    }
  }

  isMultipleSelected(row: any): boolean {
    return this.selection.selected.length >= 1 && this.selection.selected.includes(row);
  }

  isMergeColumn(column: string): column is keyof NativeSoilType {
    return [
      'inHouseId','sampleId','compactionEffort','effort','select', 'proctorDryDensity', 'specifiedDryDensity'
      , 'clientSpecifiedMoistureContent', 'assignedTo', 'drySoil', 'clientSpecifiedDensity', 'dryTr', 'dryPlusTare', 'labSpecMoistureContent'
    ].includes(column);
  }

  getSpan(row: NativeSoilType, column: string): number {
    return this.isMergeColumn(column) ? this.getRowSpan(row, column) : 1;
  }

  isHidden(row: NativeSoilType, column: string): boolean {
    return this.isMergeColumn(column) && this.getRowSpan(row, column) === 0;
  }

  isParentRow(row: any): boolean {
    return this.displayedColumns
      .filter(col => this.isMergeColumn(col))
      .some(col => this.getRowSpan(row, col as keyof NativeSoilType) > 0);
  }

  getRowSpan(element: NativeSoilType, column: keyof NativeSoilType): number {
    const index = this.dataSource.indexOf(element);
    if (index === -1) return 1;

    const prev = this.dataSource[index - 1];
    if (element.groupId == null) {
      return 1;
    }

    if (
      prev &&
      prev[column] === element[column] &&
      prev.groupId != null &&
      prev.groupId === element.groupId
    ) {
      return 0;
    }

    let count = 1;
    for (let i = index + 1; i < this.dataSource.length; i++) {
      const next = this.dataSource[i];
      if (
        next[column] === element[column] &&
        next.groupId != null &&
        next.groupId === element.groupId
      ) {
        count++;
      } else {
        break;
      }
    }
    return count;
  }

  isLastRowOfSample(row: NativeSoilType, index: number): boolean {
    const currentSampleId = row.sampleId;
    const nextRow = this.dataSource[index + 1];

    if (!nextRow) return false;
    return nextRow.sampleId !== currentSampleId;
  }

  downloadTRWorksheet(): void {
    this.nativeSoilTechWorksheetPdfService.generateTRWorksheet(
      this.worksheetRecords,
      this.workSheets,
    );
  }
}
